export const POLICIES_URL = `/policy-agents`;

export const POLICY_RUN_REPORT_URL = (
  policyId = ":policyId",
  runId = ":runId",
): string => `${POLICIES_URL}/${policyId}/runs/${runId}`;
